module.exports = __webpack_public_path__ + "static/media/egg-fried.f776624e.svg";